import { render } from "./student_verify.vue?vue&type=template&id=32df24ba"
import script from "./student_verify.vue?vue&type=script&lang=js"
export * from "./student_verify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__